import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';

export const SyncFullProntoWorkRequests = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(GetBackendUrlForGlobalFunctions() + `pronto-work-requests`, {
    headers,
  });
};
